function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

export default function insertAtIndex(arr, el, index) {
  return [].concat(_toConsumableArray(arr.slice(0, index)), [el], _toConsumableArray(arr.slice(index, arr.length)));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-validator/node_modules/fela-utils/es/insertAtIndex.js
// module id = 916
// module chunks = 0